export default "__VITE_ASSET__DIwnzAYw__"